<script setup lang="ts">
import { useRoute } from 'vue-router'
import BaseLayout from '../BaseLayout.vue'
import MainMenu from './MainMenu.vue'

const route = useRoute()
</script>

<template>
  <BaseLayout>
    <div>
      <div v-if="!route.meta.fullBleed" class="header-bar">
        <MainMenu />
      </div>

      <div :class="{ 'mt-15': !route.meta.fullBleed }">
        <router-view />
      </div>
    </div>
  </BaseLayout>
</template>
